module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_retouch-02c8baa1fb15a23912bc9f872f330b8e.png";